<h1 mat-dialog-title>{{TitleText}}</h1>
<div mat-dialog-content>
    <form>
        <p [innerHtml]="MessageText"></p>
        <mat-form-field>
            <mat-select [(ngModel)]="SelectedItem" name="SelectedItem" aria-label="Selection choices" placeholder="{{ListLabel}}">
                <mat-option *ngFor="let item of ListOptions" [value]="item.value">{{item.text}}</mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="warn" (click)="CancelHandler()">{{CancelText}}</button>
    <button mat-raised-button color="primary" (click)="OKHandler()" [disabled]="SelectedItem == null" >{{OKText}}</button>
</div>